<template>
  <div class="single-table">
    <div class="table-head">
        <h4>{{$t(title)}}</h4>
    </div>
    <div class="table-body">
        <div class="top-fields">
            <div v-for="(element, index) in header" :key="index" :class="element.class">
                <span>{{$t(element.title)}}</span>
            </div>
        </div>
        <div class="main-field-wrap">
            <div class="side-fields" v-if="sideItems != null && sideItems.length > 0">
                <div v-for="(element, index) in sideItems" :key="index" :class="element.class">
                    <span>{{$t(element.title)}}</span>
                </div>
            </div>
            <div class="main-field-block">
                <div class="row" v-for="(rowStakes, row) in stakes" :key="row">
                    <div class="main-field" v-for="(element, col) in rowStakes"
                      @click="selectedItem(element, row, col)"
                      :key="col"
                      :class="{'field-selected' :isItemSelected(row, col)}">
                        <span v-if="element.Factor > 0">{{element.Factor}}</span>
                        <span v-else></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="no-more-bets" v-if="!isBettingEnabled">
      <img src="https://cloud.aleacontrol.com/media/vDogs/bet-placed.png" alt="no-more-bets">
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import vuexStore from '../../../store/vuexStore'

import select from '../../../assets/audio/select.mp3'

export default {
  props: {
    matchNo: {
      type: Number
    },
    isBetPlaced: {
      type: Boolean,
      default: false
    },
    isBettingEnabled: {
      type: Boolean,
      default: true
    },
    activeStake: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    header: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    sideItems: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    stakesData: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    stakes: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      selectedStake: [],
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  watch: {
    activeStake: function (newActiveStake, oldActiveStake) {
      if (newActiveStake != null && !newActiveStake.isTrifecta) {
        this.selectedStake = []
      }
      if (newActiveStake === null && this.selectedStake.length === 0) {
        this.selectedStake = []
      }
    },
    selectedStake: function (newSelectedStake, oldSelectedStake) {
      this.publishEventIsStackesValid()
    }
  },
  methods: {
    resetSelectedList: function () {
      this.selectedStake = []
    },
    selectedItem: function (stake, row, col) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(select)
        audio.play()
      }
      stake['row'] = row
      stake['col'] = col
      let filteredListCol = this.selectedStake.filter(element => element.col === col)
      if (filteredListCol.length !== 0) {
        return
      }
      let filteredListRow = this.selectedStake.filter(element => element.row === row)
      if (filteredListRow.length !== 0) {
        let itemIndex = this.selectedStake.indexOf(filteredListRow[0])
        this.selectedStake.splice(itemIndex, 1)
      }
      this.selectedStake.push(stake)
      eventBus.onSelectedStakeVDog(null)
    },
    publishEventIsStackesValid: function () {
      if (this.selectedStake && this.selectedStake.length === 3) {
        let first = this.selectedStake.filter(element => element.row === 0)
        let secound = this.selectedStake.filter(element => element.row === 1)
        let third = this.selectedStake.filter(element => element.row === 2)
        let stakeId = ((first[0].col + 1) * 100) + ((secound[0].col + 1) * 10) + (third[0].col + 1)
        let stake = this.getStakeById(stakeId)
        stake.isTrifecta = true
        eventBus.onSelectedStakeVDog(stake)
      }
    },
    getStakeById: function (stakeId) {
      let filteredStakeById = this.stakesData.filter(element => element.StakeEnum === stakeId)
      return filteredStakeById.length > 0 ? filteredStakeById[0] : null
    },
    isItemSelected: function (row, col) {
      let result = false
      this.selectedStake.forEach(item => {
        if (item.row === row && item.col === col) {
          result = true
        }
      })
      return result
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VDOG_RESET, this.resetSelectedList)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VDOG_RESET, this.resetSelectedList)
  }
}
</script>
